const swedish = {
  404: {
    title: "Ops, något gick fel",
    text: "Sidan du letar efter finns inte.",
  },
  addEmployees: {
    title: "Lägg till anställda",
    step: "Steg {{step}} av {{total}}",
    next: "Fortsätt",
    back: "Tillbaka",
    submitting: "Skickar...",
    step1: {
      title: "Välj anställda",
      existingEmployees: "Befintliga anställda",
      employeeCount: "Visar {{count}} av {{total}}",
      searchLabel: "Sök bland befintliga anställda",
      searchPlaceholder: "Sök på namn eller e-post…",
      noExistingEmployees: "Inga befintliga anställda hittades",
      noSearchResults: "Inga matchande anställda hittades",
      newEmployees: "Nya anställda",
      added: "tillagda",
      new: "Ny",
      addNewEmployee: "Lägg till ny anställd",
      addButton: "Lägg till",
      removeEmployee: "Ta bort {{email}}",
    },
    step2: {
      title: "Välj utbildningar",
      defaultOffers: "Standard för alla",
      defaultOffersHelp:
        "Välj vilka utbildningar som ska gälla för alla anställda som standard.",
      employeeOffers: "Anställda",
      applyDefaultToAll: "Tilldela standard till alla",
      change: "Ändra",
      editOffersFor: "Ändra utbildningar för",
      noOffersSelected: "Inga utbildningar valda",
      recommendedOffer: "Rekommenderad baserat på ert företag",
    },
    step3: {
      title: "Sammanfattning",
      employeeSummary: "Anställda och utbildningar",
      employee: "Anställd",
      offers: "Utbildningar",
      price: "Pris",
      subtotal: "Delsumma",
      volumeDiscount: "Volymrabatt",
      employees: "anställda",
      volumeDiscountInfo:
        "Beställ {{threshold}} eller fler för att få 10% rabatt!",
      total: "Totalt",
      notesLabel: "Anteckningar (valfritt)",
      notesPlaceholder: "Skriv eventuella anteckningar här...",
      infoText:
        "När du bekräftar beställningen kommer nya användare att skapas direkt och få ett välkomstmail. Ni kommer att faktureras i efterhand.",
      confirmOrder: "Bekräfta beställning",
    },
    selectEducations: {
      title: "Välj utbildningar",
      employees: "Anställda",
      newEducationsCount: "{{count}} nya utbildningar valda",
      new: "ny",
      alreadyOwned: "Redan köpt",
      purchased: "(Köpt)",
    },
    summary: {
      title: "Sammanfattning",
      newEducations: "nya utbildningar",
      employeesAffected: "anställda",
      orderDetails: "Beställningsdetaljer",
      newEducationsColumn: "Nya utbildningar",
      educations: "utbildningar",
      volumeDiscountInfo:
        "Beställ {{threshold}} eller fler utbildningar för att få 10% rabatt!",
    },
    form: {
      firstname: "Förnamn",
      firstnamePlaceholder: "Ange förnamn",
      lastname: "Efternamn",
      lastnamePlaceholder: "Ange efternamn",
      email: "E-post",
      emailPlaceholder: "Ange e-postadress",
    },
    validation: {
      emailRequired: "E-post krävs",
      emailInvalid: "Ogiltig e-postadress",
      emailExists: "Denna e-postadress finns redan i systemet",
      firstnameRequired: "Förnamn krävs",
      lastnameRequired: "Efternamn krävs",
    },
    errors: {
      loadOffersFailed: "Kunde inte ladda utbildningar. Försök igen.",
      createOrderFailed: "Kunde inte skapa beställningen. Försök igen.",
    },
    success: {
      orderCreated: "Beställningen har skapats!",
    },
  },
  orderHistory: {
    title: "Beställningshistorik",
    noOrders: "Inga beställningar hittades",
    status: {
      pending: "Väntar på godkännande",
      approved: "Godkänd",
      rejected: "Avvisad",
    },
    columns: {
      date: "Datum",
      employees: "Anställda",
      total: "Totalt",
      status: "Status",
      invoice: "Faktura",
    },
    errors: {
      loadFailed: "Kunde inte ladda beställningshistorik",
    },
  },
  userErrors: {
    serverError: "Serverfel - försök igen senare",
    loginRequired: "Du behöver logga in igen",
    permissionDenied: "Du har inte behörighet att komma åt denna information",
    serviceUnavailable:
      "Tjänsten är tillfälligt otillgänglig - försök igen senare",
    checkConnection: "Kontrollera din internetanslutning och försök igen",
    unexpectedError: "Ett oväntat fel uppstod - försök igen senare",
  },
  account: {
    title: "Konto",
    subtitle: "Hantera dina uppgifter.",
    emailChangePrompt: "Vill du ändra e-postadress? Mejla oss på",
    emailChangeAddress: "info@finanslicenser.se",
    logout: "Logga ut",
    firstname: "Förnamn",
    surname: "Efternamn",
    email: "E-post",
    company: "Företag",
    language: "Språk",
    languageSwedish: "Svenska",
    languageEnglish: "English",
    edit: "Redigera namn",
    save: "Spara",
    cancel: "Avbryt",
    profileUpdated: "Profilen har uppdaterats",
    updateError: "Kunde inte uppdatera profilen",
    nameRequired: "Minst ett namn måste anges",
    firstnamePlaceholder: "Ange förnamn",
    surnamePlaceholder: "Ange efternamn",
    notProvided: "—",
  },
  ai: {
    greetingMessage:
      "Hej! Jag är en AI och min uppgift är att ställa några kontrollfrågor som gör det enklare för dig att minnas och förstå innehållet. Jag kan inte allt och är inte en allvetande expert, men jag är här för att påminna, förklara på en enkel nivå och göra din inlärning lite mer interaktiv. Se det som ett kort träningspass innan det är dags för de riktiga proven!",
    welcomeBackMessage: "Hej igen!",
    introMessage:
      "Hej! Nu kommer jag ställa lite kontrollfrågor för att" +
      " se att du förstått texten.",
    error: "Något gick fel vid uppstart.",
    pasteNotAllowed: "Klipp och klistra är inte tillåtet.",
    somethingWrong: "Något gick fel. Försök igen.",
    inputPlaceholder: "Skriv in ditt svar här...",
    send: "Skicka",
    modalTitle: "Finanslicenser AI",
    switchToQuestions:
      "Känns AI-chatten inte rätt för dig? Byt till traditionella frågor",
    switchToAIChat: "Vill du träna på ett nytt sätt? Prova våra AI-frågor!",
    retry: "Försök igen",
    offlineWarning: "Du är offline. Anslut till internet för att fortsätta.",
    errors: {
      offline:
        "Du verkar vara offline. Kontrollera din internetanslutning och försök igen.",
      network:
        "Kunde inte ansluta till servern. Kontrollera din internetanslutning och försök igen.",
      serviceUnavailable:
        "AI-tjänsten är tillfälligt otillgänglig. Försök igen om en stund.",
      emptyResponse:
        "Fick inget svar från AI:n. Försök igen eller byt till traditionella frågor.",
    },
    feedback: {
      title: "Vad tyckte du om chatten?",
      thumbsDown: "Dålig",
      thumbsUp: "Bra",
      placeholder: "Dela med dig av dina tankar om chatten (valfritt)...",
      submit: "Skicka feedback",
      thankYou: "Tack för din feedback! 😊",
      error: "Ett fel uppstod när feedback skickades.",
    },
    theoryChatButton: "Frågor om texten?",
    theoryChatTitle: "Fråga AI om teorin",
    theoryChatGreeting:
      "Hej! Jag är en AI-bot och jag kan svara på frågor kring teorin. Vad undrar du över?",
    theoryChatInputPlaceholder: "Ställ en fråga...",
    accuracyWarning: "AI kan ha fel. Kontrollera alltid viktig information.",
    directQuestionPlaceholder:
      "Fråga AI vad som helst om texten (tips: markera text för snabba frågor)",
    selectionSimplify: "Förklara på ett enklare sätt",
    selectionExplain: "Förklara mer",
    selectionExample: "Ge exempel",
    selectionChat: "Fråga AI",
    selectionSimplifyPrompt:
      'Kan du förenkla och förklara följande text på ett enkelt sätt?\n\n"{{text}}"',
    selectionExplainPrompt: 'Förklara vad "{{text}}" betyder.',
    selectionExamplePrompt:
      'Kan du ge ett konkret, verkligt exempel som illustrerar följande?\n\n"{{text}}"',
    selectedTextLabel: "Markerad text",
    textSelectionTip:
      "💡 Tips: Markera text i teorin för att få snabba alternativ att fråga om",
  },
  aiChatChoice: {
    title: "Välj lärandeformat",
    description:
      "Du kan välja mellan två olika sätt att träna på detta kapitel:",
    questionCount: "Detta kapitel har {{count}} frågor tillgängliga",
    saveChoice: "Spara mitt val",
    aiChat: {
      title: "AI Chat",
      description:
        "Interaktiv konversation med AI som ställer anpassade frågor baserat på innehållet. Perfekt för att fördjupa förståelsen och få personlig feedback.",
      button: "Välj AI Chat",
    },
    questions: {
      title: "Traditionella frågor",
      description:
        "Klassiska flervalsfrågor som testar dina kunskaper systematiskt. Bra för att träna inför prov och säkerställa grundläggande förståelse.",
      button: "Välj frågor",
    },
  },
  admin: {
    table: {
      allCourses: "Alla utbildning",
      addUser: "Lägg till användare",
      addCourse: "Lägg till utbildning",
      title: "Administration",
      subtitle:
        "Översikt över anställda, utbildningar och certifikat. " +
        "Ladda ner enskilda certifikat eller en sammanställning per utbildning.",
      contactPrompt:
        "Vill du lägga till användare eller utbildningar? Mejla oss på <email>info@finanslicenser.se</email> eller ring <phone>076-345 00 87</phone>.",
      description:
        "Som administratör har du här tillgång till en samlad " +
        "översikt över samtliga anställda och deras utbildningsstatus. " +
        "Du kan ladda ner individuella" +
        " certifikat eller generera en sammanställning per utbildning.",
      completed: "Avklarad",
      coursesFilter: "Visa utbildningar",
      downloadSelected: "Ladda ner valda",
      downloadMultiple: "Ladda ner samlingscertifikat",
      pickCourse: "Alla utbildningar",
      searchLabel: "Sök medarbetare",
      searchPlaceholder: "Namn eller e-post",
      coursesCompletedSummary: "{{completed}} av {{total}} utbildningar klara",
      coursesCount: "{{count}} utbildningar",
      expandEmployee: "Visa utbildningar, {{name}}",
      collapseEmployee: "Dölj utbildningar, {{name}}",
      employeeCoursesRegion: "Utbildningar för {{name}}",
      noResultsTitle: "Inga träffar",
      noResultsText: "Justera utbildningsfiltret och försök igen.",
      columns: {
        name: "Namn",
        employee: "Anställd",
        email: "E-post",
        course: "Utbildning",
        levels: "Avklarade nivåer",
        lastActivity: "Senast aktiv",
        lastCompleted: "Avklarad",
        educations: "Utbildningar",
        certificate: "Certifikat",
        download: "Ladda ner",
      },
      mailTemplate: {
        subject: "Lägg till användare",
        body: `Hej!

Jag skulle vilja lägga till en/flera användare till denna utbildning.

Här är informationen:

1. 
Förnamn: 
Efternamn: 
E-post: 
Utbildning:

2. 
Förnamn: 
Efternamn: 
E-post: 
Utbildning:

Vänligen bekräfta när användarna har lagts till i systemet.

Med vänlig hälsning,`,
      },
      mailTemplateCourse: {
        subject: "Lägg till utbildning",
        body:
          "Hej!\nJag skulle vilja lägga till denna utbildning (GDPR, " +
          "Cybersäkerhet, Penningtvätt, Sälj & marknadsföring, " +
          "Anti-korruption) för mig och mina anställda.\nVänligen bekräfta " +
          "när vi har blivit tillagda till utbildningen.",
      },
      selected: "valda",
      noData: "Inga utbildningar tillgängliga",
    },
  },
  certificates: {
    detailsSection: "Certifikatinformation",
    actionsSection: "Åtgärder",
    aboutTitle: "Om utbildningen",
    metaIssuer: "Utfärdare",
    metaIssued: "Utfärdat",
    metaValidUntil: "Giltigt till",
    titleSingle: "Ladda ner ditt certifikat",
    titleMultiple: "Ladda ner dina certifikat",
    errorDownload: "Kunde inte ladda ner certifikatet.",
    errorOpenCert:
      "Kunde inte öppna certifikatet i en ny flik. Du måste " +
      "godkänna popup blocker i din webbläsare.",
    noAvailable: "Inga certifikat tillgängliga.",
    downloadFilename: "Utbildningssammanställning.pdf",
    errorFetch: "Kunde inte hämta certifikatet.",
    educationFallback: "Utbildning",
    verified: "Verifierat",
    linkedinCertName: "Certifierad utbildning - {{education}}",
    addToLinkedIn: "Dela på LinkedIn",
    downloadDescription:
      "För att följa regler och krav på efterlevnad bör du ladda ner ditt certifikat och spara det på ett säkert ställe.",
    downloadButton: "Ladda ner certifikat",
    downloadButtonShort: "Ladda ner",
    loadingCertificate: "Laddar certifikat...",
    loadingCourse: "Laddar utbildning...",
    validUntil: "Giltigt till:",
    expiredBadge: "Utgånget",
    expiredInfo:
      "Certifikatet har gått ut. Genomför en ny årsuppdatering för att uppdatera din dokumentation.",
  },
  courseCompleted: {
    congratulationsTitle: "Grattis till avklarad utbildning!",
    congratulationsMessage: "Du har genomfört utbildningen med framgång.",
    expiredTitle: "Utbildning är avslutad",
    expiredMessage:
      "Denna utbildning är avslutad och kan inte längre genomföras eller intygas. Penningtvättsregelverket kräver fortlöpande utbildning, och certifikat för årsuppdateringar gäller i 12 månader från slutförandet. Kontakta oss om du behöver göra en ny årsuppdatering.",
    expiredDiscountOfferBefore:
      "Vi förstår att det kan kännas frustrerande, och vi vill gärna hjälpa dig vidare. Hör av dig till oss på ",
    expiredDiscountOfferAfter: " så ordnar vi 50% rabatt på AML 2026 åt dig.",
    error:
      "Ett fel inträffade när certifikaten skulle hämtas." +
      " Försök igen senare.",
    noCertificateAvailable:
      "Detta certifikat är inte tillgängligt för denna utbildning.",
    loading: "Certifikat laddas. Var god vänta...",
    showCertificate: "Visa certifikat",
    popup: {
      badge: "Avslutad utbildning",
      title: "Grattis till avklarad utbildning!",
      subtitle:
        "Du har framgångsrikt klarat alla moment och slutfört " +
        "utbildningen!",
    },
  },
  confirmationPopup: {
    stay: "Stanna kvar",
  },
  components: {
    breadcrumbs: "Brödsmulor",
    pages: "Sidor",
    previousPage: "Föregående sida",
    nextPage: "Nästa sida",
    notices: "Meddelanden",
    previousNotice: "Föregående meddelande",
    nextNotice: "Nästa meddelande",
    closeNotices: "Stäng meddelanden",
  },
  education: {
    notAvailable: {
      title: "Läs mer om denna utbildning och boka direkt på hemsidan.",
    },
  },
  educationContent: {
    loadingSteps: "Laddar kursens steg",
    levelsLoadError:
      "Kunde inte ladda stegen. Kontrollera din internetanslutning och försök igen.",
    courseDataLoadError:
      "Kunde inte ladda utbildningen. Kontrollera din internetanslutning och försök igen.",
    multipleChoice: {
      noAvailable: "Inga frågor tillgängliga",
    },
    fillInBlank: {
      noData: "Ingen fill-in-blank data tillgänglig",
      wordBankLabel: "Dra/tryck på rätt ord för att flytta till tomma fält:",
      allWordsPlaced: "Alla ord har placerats",
      blankFilled: "Fält fyllt med: {{word}}",
      blankEmpty: "Tomt fält, klicka för att placera ett ord",
    },
    confirationPopup: {
      badge: "Låst",
      title: "Steget låst",
      message:
        "Du kan inte hoppa framåt. Följ ordningen för att säkerställa" +
        " att du inte missar viktig information.",
      messageDiagnostic: "Du kan endast göra ett diagonstisk test en gång.",
    },
    quiz: {
      title: "Delprov",
    },
  },
  feedbackView: {
    title: "Tack så mycket",
    subtitle: "Vad tyckte du om utbildningen?",
    headerTitle:
      "Om du har möjlighet får du gärna fortsätta att betygsätta " +
      "din upplevelse.",
    questionTitle: "Har du några övriga kommentarer?",
    save: "Skicka",
    saving: "Skickar...",
    skip: "Hoppa över",
    thankYouBody: "Din feedback hjälper oss att förbättra utbildningarna.",
    sentiment: {
      veryBad: "Väldigt dålig",
      bad: "Dålig",
      neutral: "Helt Ok",
      good: "Bra",
      veryGood: "Väldigt bra",
    },
    modal: {
      noAuth: "Användaren är inte autentiserad. Logga in och försök igen.",
      questions: {
        recommend: "Skulle du rekommendera utbildningen till en kollega?",
        easyToUse: "Hur lätt var det att använda utbildningsplattformen?",
        materialQuality: "Hur bedömer du kvaliteten på innehållet?",
        aiChatQuality: "Vad tyckte du om den interaktiva AI-chatten?",
        roleplayQuality: "Vad tyckte du om rollspelsövningarna?",
      },
      questionFeedback:
        "Berätta gärna mer varför du inte gillade {{question}} (Valfritt)",
      questionFeedbackPlaceholder: "Skriv din feedback här...",
      questionShortDescriptions: {
        recommend: "rekommendationen",
        easyToUse: "plattformen",
        materialQuality: "innehållet",
        aiChatQuality: "AI-chatten",
        roleplayQuality: "rollspelsövningarna",
        overall: "utbildningen",
      },
    },
  },
  header: {
    progress: "{{progress}}% avklarat",
    fortnoxPartnershipLogoAlt: "I samarbete med Fortnox",
  },
  educationSnake: {
    pageSubtitle: "Gå igenom stegen i din egen takt.",
  },
  educationOverview: {
    stepsCompleted: "{{completed}} av {{total}} steg avklarade",
    ofTotal: "av {{total}}",
    start: "Starta utbildningen",
    continue: "Fortsätt",
    nextStep: "Nästa: {{label}}",
  },
  reviewPopup: {
    title: "Grattis till avklarad utbildning!",
    badge: "Avslutad utbildning",
    subtitle:
      "Du har framgångsrikt klarat alla moment och slutfört utbildningen!",
  },
  levels: {
    startHere: "Börja här",
    youAreHere: "Du är här",
    examShort: "Prov",
    quizShort: "Quiz",
    section: "Avsnitt {{number}}",
    sectionDone: "{{count}} av {{count}} klara",
    sectionInProgress: "Pågår · {{completed}} av {{total}}",
    sectionUpcoming: "{{count}} steg",
    certificateGoal: {
      title: "Certifikat",
      locked: "Du får ditt certifikat när du klarat slutprovet.",
      open: "Öppna ditt certifikat",
      unlocked: "Klart! Öppna ditt certifikat.",
    },
    theory: {
      title: "",
      faq: {
        title: "Vanliga frågor",
        subtitle: "Svar på vanliga frågor om kapitlet",
        showAll: "Visa alla frågor",
        showLess: "Visa färre",
        questionsCount: "{{count}} frågor",
      },
      tts: {
        listen: "Lyssna",
        play: "Spela",
        playing: "Spelar...",
        paused: "Pausad",
        loading: "Laddar ljud...",
        error: "Kunde inte spela upp",
        stop: "Stoppa",
        progress: "Uppspelningsposition",
      },
    },
    missing: "Nivån saknas eller kunde inte laddas.",
    header: {
      badge: "Lämna steget",
      title: "Vill du lämna detta steg?",
      subtitle: "Du behöver börja om steget om du avbryter nu.",
    },
    readMore: "Läs hela texten",
    video: {
      title: "Video",
      loadingPoster: "Laddar förhandsvisning",
    },
    completeLevel: "Slutför nivån",
    questions: {
      explanationBox: "Förklaring",
    },
    quiz: {
      title: "Delprov",
      description:
        "Du får besked direkt efter varje fråga om du svarade rätt.",
      start: "Starta delprovet",
      startTest: "Starta provet",
      loadingLevels: {
        text: "Laddar nivåer",
      },
    },
    startScreen: {
      factsLabel: "Om provet",
      questions: "Frågor",
      passRequirement: "Godkänt från",
      passRequirementValue: "{{percentage}} % rätt",
    },
  },
  questions: {
    answers: {
      yes: "Ja",
      no: "Nej",
      true: "Sant",
      false: "Falskt",
    },
  },
  report: {
    title: "Feedback",
    titleQuestion: "Vad handlar din feedback om?",
    subtitleSelect: "Vad handlar din feedback om?",
    button: "Feedback",
    categories: {
      spelling: "Stavfel",
      factual: "Faktafel",
      feedback: "Förslag på förbättring",
      other: "Övrigt",
    },
    commentsLabel: "Berätta mer (Valfritt)",
    send: "Skicka",
    toastSuccess: "Tack! Din feedback är skickad!",
    errors: {
      notAuthenticated: "Du måste vara inloggad för att rapportera.",
      generic: "Kunde inte skicka rapporten. Försök igen senare.",
      tooLong: "Texten får vara max 5000 tecken.",
      missingCategory: "Välj en kategori.",
    },
  },
  menu: {
    progressPercent: "{{progress}} %",
    progressAria: "{{progress}} % klart",
    progressCompleted: "Avklarad",
    close: "Stäng meny",
    collapseSidebar: "Minimera sidomenyn",
    expandSidebar: "Visa sidomenyn",
    account: "Konto",
    admin: "Administration",
    adminLink: "Admin",
    adminTitle: "Admin",
    buttonTitle: "Meny",
    brandLogoAlt: "Finanslicenser",
    certificate: "Certifikat",
    myCertificates: "Mina certifikat",
    myEducations: "Mina utbildningar",
    educations: "Utbildningar",
    expiredEducations: "Utgångna utbildningar",
    noActiveEducations: "Inga aktiva utbildningar.",
    loadingEducations: "Laddar utbildningar",
    followOnLinkedIn:
      "Följ Finanslicenser på LinkedIn för nyheter och erbjudanden",
    followOnLinkedInShort: "Följ oss på LinkedIn",
  },
  certificatesPage: {
    title: "Mina certifikat",
    description:
      "Alla certifikat du har fått, samlade på ett ställe. Klicka på ett" +
      " certifikat för att visa eller ladda ner det.",
    emptyTitle: "Inga certifikat ännu",
    emptyDescription:
      "När du har slutfört en utbildning dyker certifikatet upp här.",
    untitled: "Certifikat",
    completed: "Utfärdat",
    valid: "Giltigt",
    expired: "Utgånget",
    dateUnknown: "Datum saknas",
    loadError: "Kunde inte hämta dina certifikat. Försök igen.",
    thumbnailError: "Kunde inte visa",
    openCertificate: "Öppna certifikat för {{title}}",
    nextTitle: "Hitta din nästa utbildning",
    nextDescription:
      "Vi har scannat Finanslicenser.se och plockat ut utbildningar som" +
      " hjälper dig att ta nästa steg. Bygg vidare på dina certifikat och" +
      " stärk din kompetensprofil.",
    nextCta: "Se utbildningen →",
    catalogNote:
      "Vill du ha hela utbildningskatalogen? Besök <link>Finanslicenser.se</link> för aktuellt utbud.",
    catalogCta: "Till Finanslicenser.se",
    recommendations: {
      penningtvatt: {
        title: "Penningtvätt",
        description:
          "Anpassad för redovisningskonsulter, betaltjänstbolag m.fl.",
        tag: "Compliance",
      },
      gdpr: {
        title: "GDPR",
        description: "Fokus på hantering av personuppgifter och dataskydd.",
        tag: "Dataskydd",
      },
      antikorruption: {
        title: "Anti-korruption",
        description:
          "Lär dig identifiera och förebygga korruption i verksamheten.",
        tag: "Compliance",
      },
      tolvregeln: {
        title: "3:12-regeln",
        description:
          "Anpassad för redovisningskonsulter som arbetar med fåmansbolag.",
        tag: "Skatt",
      },
      cybersakerhet: {
        title: "Cybersäkerhet",
        description: "Konkreta åtgärder för att skydda ditt företag.",
        tag: "Säkerhet",
      },
    },
  },
  levelCompleted: {
    title: "Steget avklarat!",
    message: "Du är nu redo att gå vidare",
  },
  login: {
    error: "Kunde inte logga in. Försök igen.",
    mobileMessage:
      "För bästa upplevelse, vänligen använd en dator för att logga in och" +
      " genomföra utbildningen.",
    mobileCTA: "Ladda ner appen",
    logoTitle: "Utbildningar inom bank och finans.",
    button: "Logga in",
    email: "E-post",
    password: "Lösenord",
    passwordPrompt: "Minst 6 tecken",
    forgotPassword: "Glömt ditt lösenord?",
    clickHere: "Klicka här",
    enterEmail: "Ange din e-postadress ovan för att återställa lösenordet.",
    resetEmailSent:
      "Om e-postadressen finns skickades en länk för återställning.",
    resetCheckSpamBefore: "Kolla ",
    resetCheckSpamBold: "skräppost",
    resetCheckSpamAfter: "en ifall mailet inte kommer fram",
    resetError:
      "Kunde inte skicka återställningsmejlet. Kontrollera e-postadressen och försök igen.",
    resetButton: "Återställ lösenord",
    backToLogin: "Tillbaka till inloggning",
    emailTemplate: {
      forgotPasswordSubject: "Begäran om återställning av lösenord",
      forgotPasswordBody:
        "Hej,\n\nJag behöver hjälp med att " +
        "återställa mitt lösenord.\nSkulle ni kunna skicka ett nytt " +
        "lösenord till mig?",
    },
  },
  quizSuccessPopup: {
    title: "Godkänd",
    badge: "Godkänd",
    scoreUnit: "%",
    correctCount: "{{totalCorrectAnswers}} av {{totalAnswers}} frågor rätt",
    progressLabel: "{{percentageCorrect}} procent rätt",
    message: "Grattis, du klarade delprovet.",
    submessage: "({{totalCorrectAnswers}} / {{totalAnswers}} frågor)",
  },
  diagnosticTest: {
    title: "Diagnostiskt test",
    bottomText:
      "Detta är ett diagnostiskt test. Ämnen du redan behärskar " +
      "kommer att exkluderas från din utbildning, medan områden du behöver" +
      " förbättra kommer att repeteras i kommande lektioner.",
    start: "Starta testet",
    loadingLevels: {
      text: "Anpassar nivåerna för dig",
    },
  },
  diagnosticTestPopup: {
    title: "Test avklarat",
    badge: "Test avklarat",
    correctCount: "{{totalCorrectAnswers}} av {{totalAnswers}} frågor rätt",
    message: "Diagnostiskt test slutfört.",
    body:
      "Baserat på dina resultat kan vi nu skräddarsy en utbildningsplan" +
      " som matchar din kunskapsnivå.",
    submessage: "({{totalCorrectAnswers}} / {{totalAnswers}} frågor) rätt",
    areasToImprove: "Områden att repetera",
    masteredAreas:
      "Kompetens bekräftad (Du behöver inte repetera dessa områden)",
    error: "Ett fel uppstod",
    unknownArea: "Okänt område",
  },
  tabbar: {
    stepByStep: "Steg för steg",
    theory: "Teori",
    exercise: "Övningsfrågor",
    certificate: "Certifikat",
    documents: "Dokument",
  },
  documents: {
    subtitle: "Ladda ner utbildningsmaterial och dokument",
    download: "Ladda ner",
    empty: "Inga dokument tillgängliga",
  },
  theoryList: {
    title: "Teori",
    subtitle: "Läs alla kapitel i din egen takt.",
    other: "Övrigt",
    itemFallback: "Teori",
    lockedTitle: "Denna vy är låst",
    lockedMessage:
      "Slutför alla steg under 'Steg för steg'-fliken för att få ditt certifikat och för att låsa upp teoriavsnitten.",
    lockedPopupTitle: "Innehållet är låst",
    lockedPopupMessage:
      "Du måste slutföra alla steg i 'Steg för steg'-fliken innan du kan läsa detta teoriavsnitt.",
    lockedPopupButton: "Jag förstår",
  },
  practice: {
    emptyCategories: "Inga kategorier hittades.",
    ctaMany: "Öva på {{count}} kategorier",
    ctaAll: "Öva på allt",
    examTitle: "Övningsprov",
    examDescription: "Här kan du göra övningsprov. (Kommer snart)",
  },
  quizFailedPopup: {
    title: "Underkänd",
    badge: "Underkänd",
    correctCount: "{{totalCorrectAnswers}} av {{totalAnswers}} frågor rätt",
    message:
      "Du fick {{percentageCorrect}}% rätt. Du kan göra om" +
      " provet när som helst tills du når minst 70%.",
    submessage: "({{totalCorrectAnswers}}/{{totalAnswers}} frågor)",
  },
  roleplay: {
    title: "Rollspel",
    defaultSceneDescription: "📩 Svara på uppgiften nedan.",
    placeholder: "Skriv din motivering...",
    loadingResponding: "Svarar...",
    loadingEvaluating: "Utvärderar...",
    send: "Skicka",
    analyzeAnswer: "Analysera",
    analysis: "Analys",
    explanation: "Förklaring",
    analyzing: "Analyserar...",
    analysisComplete: "Analysen klar. Din score blev: {{score}}%",
    goodExampleTitle: "Exempel på bra svar",
    retry: "Försök igen",
    yourAnswer: "Ditt svar",
    fetching: "Hämtar...",
    stepCompletedAnalyzing: "Steg klara. Analys pågår nedan.",
    previousSteps: "Tidigare steg",
    conversationEnded: "Dialogen avslutad.",
    assistantInitial: "K",
    userInitial: "D",
    imageAlt: "rollspel",
    imageLoadError: "Kunde inte ladda bilden",
    feedback: {
      title: "Hur var rollspelsträningen?",
      thumbsDown: "Dålig",
      thumbsUp: "Bra",
      placeholder:
        "Dela med dig av dina tankar om rollspelsträningen (valfritt)...",
      submit: "Skicka feedback",
      thankYou: "Tack för din feedback! 😊",
      error: "Ett fel uppstod när feedback skickades.",
    },
    errors: {
      generic: "Ett fel inträffade. Försök igen senare.",
      simulationFetch: "Kunde inte hämta svar från simuleringen.",
      stepGeneric: "Ett fel inträffade. Försök igen.",
      evaluationFailed: "Utvärderingen misslyckades",
      parseFailed: "Kunde inte tolka utvärderingen",
    },
  },
  branchingStory: {
    title: "Interaktiv berättelse",
    notFound: "Berättelsen kunde inte hittas.",
    noNodes: "Berättelsen saknar innehåll.",
    start: "Börja utredningen",
    storyEnd: "Slut",
    endingGood: "Utmärkt!",
    endingAcceptable: "Bra jobbat!",
    endingBad: "Misslyckat slut",
    completed: "Avslutad",
    yourChoices: "Dina val",
    tryAgain: "Prova igen",
    whatWentWrong: "Vad gick fel?",
    levelCompleted: "Nivån är avklarad",
    allQuestionsAnswered: "Du har besvarat alla frågor korrekt!",
  },
  common: {
    continue: "Fortsätt",
    completed: "avklarat",
    ok: "OK",
    cancel: "Avbryt",
    close: "Stäng",
    error: "Något gick fel",
    errorOccurred: "Ett fel uppstod",
    errorTryAgain: "Något gick fel, försök igen senare.",
    tryAgain: "Försök igen",
    loading: "Laddar...",
    quit: "Lämna",
    readMore: "Läs mer",
    readInDepth: "Läs mer",
    closeInDepth: "Stäng",
    done: "Klar",
  },
  welcome: {
    title: "Välkommen till Finanslicenser",
    subtitle: "Klicka på menyn för att välja utbildning",
    arrowText: "Välj utbildning här.",
    noCourses: "Du har inga aktiva utbildningar för tillfället.",
  },
  error: {
    title: "Något gick fel",
    generic: "Ett oväntat fel uppstod. Försök igen.",
    retry: "Försök igen",
    coursesLoadFailed:
      "Kunde inte ladda utbildningar. Kontrollera din internetanslutning och försök igen.",
    userCoursesLoadFailed:
      "Kunde inte ladda dina utbildningar. Försök igen senare.",
  },
  referralLanding: {
    hero: {
      title: "{{name}} ({{company}}) har bjudit in dig",
      subtitle: "Du får {{discount}}% rabatt första året!",
      discountBadge: "{{discount}}% rabatt första året",
      rating: "{{rating}} av 5",
    },
    packages: {
      title: "Välj ditt paket",
      originalPrice: "Ordinariepris {{price}}",
      recommended: "Populärast",
      perPersonYear: "per person / år",
      save: "Spara {{amount}}",
      readMore: "Läs mer",
    },
    form: {
      title: "Registrera ditt företag",
      contactPerson: "Kontaktperson",
      contactPersonPlaceholder: "Ange kontaktpersonens namn",
      orgNumber: "Organisationsnummer",
      orgNumberPlaceholder: "Ange organisationsnummer",
      email: "E-post",
      emailPlaceholder: "Ange e-postadress",
      participantCount: "Antal deltagare",
      participantCountPlaceholder: "Ange antal deltagare",
      acceptTerms: "Jag godkänner villkoren",
      submit: "Skicka registrering",
      submitting: "Skickar...",
    },
    errors: {
      contactPersonRequired: "Kontaktperson krävs",
      orgNumberRequired: "Organisationsnummer krävs",
      orgNumberInvalid:
        "Ogiltigt organisationsnummer (måste vara 10 eller 12 siffror)",
      emailRequired: "E-post krävs",
      emailInvalid: "Ogiltig e-postadress",
      participantCountRequired: "Antal deltagare krävs",
      participantCountInvalid: "Antal deltagare måste vara minst 1",
      packageRequired: "Välj ett paket",
      termsRequired: "Du måste godkänna villkoren",
    },
    success: {
      message: "Tack! Din registrering har skickats. Vi kontaktar dig snart.",
    },
  },
};

export default swedish;
